
import { RouterNameEnum } from '@/router/router.types';
import PultLogo from '@/UI/components/brand/PultLogo.vue';
import {AdminMenu, OwnerMenu, MenuItem, NetworkOwnerMenu} from "@/utils/menu";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {getStudioId} from "@/UI/lib/state";

@Component({ components: { PultLogo } })
export default class SideBar extends Vue {
  @Prop() userData!: any;
  menuData: Array<MenuItem> = [];
  selected_keys: string[] = [];

  @Watch("$store.state.salon_id", {immediate: false})
  async onStudioChange(): Promise<void> {
    await this.SetMenuData(this.userData);
  }

  @Watch('$route', {immediate: false})
  onRouteChange() {
    this.selected_keys = [];
    if (this.$route && this.$route.matched && this.$route.matched[1] && this.$route.matched[1].meta.alias) {
      this.selected_keys = [this.$route.matched[1].meta.alias.toString()];
    }
  }

  async SetMenuData(Data: any): Promise<void> {
    const studio_id = Number.isInteger(Number(getStudioId(this))) ? Number(getStudioId(this)) : undefined;
    const salonRole = Vue.auth.check('owner') || Vue.auth.check('manager') || Vue.auth.check('reception');
    if (Vue.auth.check("admin")) {
      this.menuData = AdminMenu(studio_id);
    }
    if (salonRole) {
      //const user = Vue.auth.user();
      this.menuData = OwnerMenu(studio_id);
      if (Vue.auth.check('owner')) {
        const companyMenu = AdminMenu(studio_id);
        this.menuData[0] = companyMenu[0];
        this.menuData.push(...companyMenu.filter(item => item.link === RouterNameEnum.Settings));
      }
    }
    if (Vue.auth.check('network')) {
      this.menuData = NetworkOwnerMenu(studio_id)
    }
    if (!salonRole && !Vue.auth.check("admin") && !Vue.auth.check("network")) {
      this.menuData = [];
    }
  }

  created(): void {
    this.SetMenuData(this.userData);
    if (this.$route && this.$route.matched && this.$route.matched[1] && this.$route.matched[1].meta.alias) {
      this.selected_keys = [this.$route.matched[1].meta.alias.toString()];
    }
  }
}
